(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nav-categories"] && !Shopify.designMode) return;
  try {
    (function(){
  var nav=document.querySelector('[data-ncat]'); if(!nav) return;
  var touch=window.matchMedia('(max-width:900px)');
  nav.querySelectorAll('[data-ncat-top]').forEach(function(top){
    top.addEventListener('click',function(e){
      var li=top.parentNode;
      var url=li.getAttribute('data-ncat-url');
      if(!touch.matches){
        // desktop: hover shows the dropdown, click goes to the collection
        if(url) window.location.href=url;
        return;
      }
      var open=li.classList.contains('is-open');
      // right side of the row = arrow zone: open/close ONLY, never navigate
      var rect=top.getBoundingClientRect();
      var arrowZone = e.clientX > rect.right - 64;
      if(open && !arrowZone && url){
        window.location.href=url;
        return;
      }
      nav.querySelectorAll('.ncat__item').forEach(function(i){i.classList.remove('is-open');});
      if(!open) li.classList.add('is-open');
    });
  });

  // scroll cue: flag any dropdown that actually overflows
  nav.querySelectorAll('.ncat__dd').forEach(function(dd){
    var upd=function(){ dd.classList.toggle('has-more', dd.scrollHeight - dd.scrollTop - dd.clientHeight > 12); };
    dd.addEventListener('scroll', upd, {passive:true});
    var li=dd.closest('.ncat__item');
    if(li) li.addEventListener('mouseenter', function(){ setTimeout(upd, 60); });
  });

  // mobile drawer — toggled by the burger in the header top row
  var burger=document.querySelector('[data-bth-burger]');
  if(burger) burger.addEventListener('click',function(){
    var open=nav.classList.toggle('is-open');
    burger.classList.toggle('is-open', open);
    burger.setAttribute('aria-expanded', open?'true':'false');
    burger.setAttribute('aria-label', open?'Close menu':'Open menu');
  });
  document.addEventListener('brand:changed',function(){
    nav.classList.remove('is-open');
    if(burger){ burger.classList.remove('is-open'); burger.setAttribute('aria-expanded','false'); }
    nav.querySelectorAll('.ncat__item').forEach(function(i){ i.classList.remove('is-open'); });
  });
  // Predictive search — Shopify suggest API, debounced; click result -> PDP
  var form=nav.querySelector('[data-ncat-search]');
  if(form){
    var input=form.querySelector('[data-ncat-q]');
    var panel=form.querySelector('[data-ncat-results]');
    var timer=null, lastQ='', seq=0;
    var close=function(){ panel.hidden=true; panel.innerHTML=''; };
    var esc=function(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(ch){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]; }); };
    var render=function(products,q){
      if(!products.length){
        panel.innerHTML='<div class="ncat__results-empty">Nothing for “'+esc(q)+'” — try another word.</div>';
        panel.hidden=false; return;
      }
      panel.innerHTML=products.map(function(p){
        var imgUrl=p.featured_image&&p.featured_image.url;
        var img=imgUrl
          ? '<img class="ncat__result-img" src="'+esc(imgUrl+(imgUrl.indexOf('?')>-1?'&':'?')+'width=120')+'" alt="" loading="lazy">'
          : '<span class="ncat__result-img ncat__result-ph">'+esc((p.title||'?').charAt(0))+'</span>';
        var price=String(p.price||'');
        if(price && price.charAt(0)!=='$') price='$'+price;
        return '<a class="ncat__result" href="'+esc(p.url)+'">'
          + img
          + '<span><span class="ncat__result-name">'+esc(p.title)+'</span>'
          + (p.type?'<span class="ncat__result-type">'+esc(p.type)+'</span>':'')+'</span>'
          + '<span class="ncat__result-price">'+esc(price)+'</span>'
          + '</a>';
      }).join('');
      panel.hidden=false;
    };
    // mobile "locked-in" search mode
    var cancel=form.querySelector('[data-ncat-cancel]');
    var searching=false;
    var hint=function(){
      panel.innerHTML='<div class="ncat__results-empty">Start typing to search…</div>';
      panel.hidden=false;
    };
    var enterSearch=function(){
      if(searching || !window.matchMedia('(max-width:900px)').matches) return;
      searching=true;
      nav.classList.add('is-searching');
      panel.style.height=Math.max(240, window.innerHeight - form.getBoundingClientRect().bottom - 8)+'px';
      document.body.style.overflow='hidden';
      if(panel.hidden) hint();
    };
    var exitSearch=function(){
      if(!searching) return;
      searching=false;
      nav.classList.remove('is-searching');
      panel.style.height='';
      document.body.style.overflow='';
      close();
      input.blur();
    };
    input.addEventListener('focus', enterSearch);
    if(cancel) cancel.addEventListener('click', exitSearch);
    // dismissal helpers — registered in the capture phase further down so a
    // press outside closes the panel without depending on focus/blur (the
    // mobile keyboard being dismissed must NOT close the suggestions)
    var dismiss=function(){ close(); exitSearch(); };
    var outside=function(e){ if(!form.contains(e.target)) dismiss(); };

    input.addEventListener('input',function(){
      var q=input.value.trim();
      clearTimeout(timer);
      if(q.length<2){ lastQ=q; if(searching){ hint(); } else { close(); } return; }
      timer=setTimeout(function(){
        if(q===lastQ) return;
        lastQ=q;
        var mySeq=++seq;
        fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide')
          .then(function(r){ return r.json(); })
          .then(function(d){
            if(mySeq!==seq) return; // a newer query answered already
            var products=(d.resources&&d.resources.results&&d.resources.results.products)||[];
            render(products,q);
          })
          .catch(close);
      },200);
    });
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var first=panel.querySelector('.ncat__result');
      if(first){ window.location.href=first.getAttribute('href'); }
    });
    if(window.PointerEvent){
      document.addEventListener('pointerdown', outside, true);
    } else {
      document.addEventListener('mousedown', outside, true);
      document.addEventListener('touchstart', outside, {capture:true, passive:true});
    }
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') dismiss(); });
    input.addEventListener('focus',function(){ if(panel.innerHTML && input.value.trim().length>=2) panel.hidden=false; });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
